import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SubscribeAndUnsubscribeComponent from './SubscribeAndUnsubscribeComponent';
import { getModel } from '../selectors';
import * as actions from '../actions';

const SubscribeAndUnsubscribeLoggerContainer = (props) => {
    return <SubscribeAndUnsubscribeComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return { model };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const SubscribeAndUnsubscribeLoggerContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(SubscribeAndUnsubscribeLoggerContainer);

export default SubscribeAndUnsubscribeLoggerContainerConn;
